import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "../../../lib/axios";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CustomAutoCompleteNew from '../../AutoComplete/CustomAutoCompleteNew';


const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'CountryName', label: 'Country', minWidth: 170 },
    { id: 'StateName', label: 'State', minWidth: 170 },
    { id: 'StateAbrv', label: 'ShortName', minWidth: 100 },
    { id: 'StateCode', label: 'StateCode', minWidth: 100 }
];

const State = () => {

    const [formData, setFormData] = useState({
        CountryName: '',
        StateName: '',
        StateCode: '',
        ShortName: ''
    });

    // const permissions = useModulePermissions("State Master");

    const [error, setError] = useState({
        country: false,
        stateName: false,
        stateCode: false
    });

    const navigate = useNavigate();

    const [countries, setCountries] = useState([]);
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [countryIds, setCountryIds] = useState([]);
    const location = useLocation();
    const [currentStateId, setCurrentStateId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedStateId, setLastInsertedStateId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const UserId = sessionStorage.getItem('UserId')
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
      const [isRefreshingCountries, setIsRefreshingCountries] = useState(false);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const countryRef = useRef(null);
    const stateNameRef = useRef(null);
    const stateCodeRef = useRef(null);
    const shortNameRef = useRef(null);

       const openCountryTab = () => {
            window.open('/country');
        }
    
        const handleRefreshCountries = async () => {
            setIsRefreshingCountries(true);
            try {
                const response = await axios.get(`StateMst/getcountydrp`);
                setCountries(response.data.Data);
                const idMapping = response.data.Data.reduce((acc, country) => {
                    acc[country.name] = country.id;
                    return acc;
                }, {});
                setCountryIds(idMapping);
            } catch (err) {
                console.error('Error refreshing countries:', err);
            } finally {
                setTimeout(() => {
                    setIsRefreshingCountries(false);
                }, 300);
            }
        };

    useEffect(() => {
        if (location.state && location.state.StateId) {
            setCurrentStateId(location.state.StateId);
            fetchStateData(location.state.StateId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchStateData = async (id, flag) => {
        try {
            const response = await axios.post('stateMst/RetrivestateMst', {
                StateId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const stateData = response.data.Data[0];
                setFormData({
                    CountryName: stateData.CountryId.toString() || '',
                    StateName: stateData.StateName,
                    StateCode: stateData.StateCode,
                    ShortName: stateData.StateAbrv
                });
                flag === "D" && toast.success(response.data.Message);
                setIsFormDisabled(true);
                setStatus(stateData.Status.toString() || "0");
                setCurrentStateId(stateData.StateId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch state data');
            }
        } catch (error) {
            console.error('Error fetching state data:', error);
            toast.error('Error fetching state data. Please try again.');
        }
    };

    const handlePrevious = async () => {
        if (currentStateId && currentStateId > 1) {
            await fetchStateData(currentStateId, "P");
        }
    };

    const handleNext = async () => {
        if (currentStateId) {
            await fetchStateData(currentStateId, "N");
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('stateMst/getAllstateMstDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const getCountries = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}StateMst/getcountydrp`
                );
                setCountries(response.data.Data);
                const idMapping = response.data.Data.reduce((acc, country) => {
                    acc[country.name] = country.id;
                    return acc;
                }, {});
                setCountryIds(idMapping);
            } catch (err) {
                console.log(err);
            }
        };
        getCountries();
    }, []);


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));


        if (name === 'state') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'state' && value !== '') {
            setTimeout(() => {
                shortNameRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === countryRef.current) {
                stateNameRef.current.focus();
            } else if (event.target === stateNameRef.current) {
                stateCodeRef.current.focus();
            } else {
                shortNameRef.current.focus();
            }
        }
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.CountryName) {
            toast.error('Country name is required');
            setError(prev => ({ ...prev, CountryName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, CountryName: false }));
        }

        if (!formData.StateName) {
            toast.error('State name is required');
            setError(prev => ({ ...prev, StateName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, StateName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                CountryId: parseInt(formData.CountryName),
                StateName: formData.StateName,
                StateCode: formData.StateCode,
                StateAbrv: formData.ShortName,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.StateId = currentStateId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch('stateMst/UpdatestateMst', payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post('stateMst/InsertstateMst', payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedStateId(response.data.Data)
                    await fetchStateData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentStateId(response.data.Data);
                } else {
                    await UnLock(currentStateId, "MstState", "StateId");
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating state:', error);
            toast.error('Error saving/updating state. Please try again.');
        }
    };

    const handleEdit = async () => {

        let Flag = await checkAndLock(currentStateId, "MstState", "StateId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            CountryName: '',
            StateName: '',
            StateCode: '',
            ShortName: ''
        });
        setCurrentStateId(null);

        setTimeout(() => {
            countryRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchStateData(1, "L");
            await UnLock(currentStateId, "MstState", "StateId");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            CountryName: '',
            StateName: '',
            CityCode: '',
            ShortName: ''
        });
        setCurrentStateId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/statetable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {

        let Flag = await checkAndLock(currentStateId, "MstState", "StateId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchStateData(currentStateId, "D");
                await fetchStateData(currentStateId, "N");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });

        }

    };

    return (
        <>

            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentStateId || currentStateId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentStateId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            State Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="State Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12} md={6} lg={6} className='form_field'>
                        <CustomAutoCompleteNew
                            options={countries}
                            id="CountryName-autocomplete"
                            name='CountryName'
                            label={
                                <span>
                                    Country <span style={{ color: 'red' }}>*</span>
                                </span>
                            }
                            value={
                                countries.find(
                                  (CountryName) => CountryName.Id == formData.CountryName
                                ) || null
                              }
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.CountryName}
                            helperText={error.CountryName ? '' : ''}
                            ref={countryRef}
                            onKeyDown={handleKeyPress}
                            onAddClick={openCountryTab}
                            onRefreshClick={handleRefreshCountries}
                            isRefreshing={isRefreshingCountries}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <TextField
                            id="StateName"
                            name="StateName"
                            label="State"
                            variant="filled"
                            fullWidth
                            className="custom-textfield"
                            value={formData.StateName}
                            onChange={handleInputChange}
                            disabled={isFormDisabled}
                            error={error.StateName}
                            helperText={error.StateName && ""}
                            inputRef={stateNameRef}
                            onKeyDown={handleKeyPress}
                        />
                    </Grid>
                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="StateCode"
                                    name="StateCode"
                                    label="State Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.StateCode}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.stateCode}
                                    helperText={error.stateCode && ""}
                                    inputRef={stateCodeRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    id="ShortName"
                                    name="ShortName"
                                    label="Short Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ShortName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={shortNameRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2} >
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="State Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default State